<template>
    <a href="javascript:void(0)" class="tabs-trigger" @click="handleClick(name)" v-bind:class="{'active': active == name}">
        <slot />
    </a>
</template>

<script>
export default {
    props: {
        handleClick: Function,
        name: String,
        active: String,
        opened: String
    }
}
</script>

<style lang="scss" scoped>
    .tabs-trigger {
        position: relative;
        padding: 0.5rem 1.25rem;

        text-decoration: none;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        color: #2460B8;
        border: 1px solid #2460B8;

        @media screen and (max-width: 650px) {
            display: block;
            margin-bottom: 10px;

            border-radius: 5px;

            &:last-child {
                margin-bottom: 0px;
            }
        }

        i {
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
        }

        span {
            display: inline-block;
            vertical-align: middle;
        }

        @media screen and (min-width: 650px) {
            &.active {
                background: #2460B8;
                color: white;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/Tabs/Trigger.vue